<template>
	<div>
		<!-- 基本信息 -->
		<div class="Minister-top information" v-if="isShowBianti">
			<div class="Minister-top-top Ministerbackground">
				<div class="Minister-top-left Minister-top-color">变体设置</div>
				<div class="bianti_desc">（仅填写一行内容时，为无变体）</div>
			</div>
			<div class="information_content">
				<div style="width: 100%;display: flex;justify-content: space-between;font-size: 16px">
					<div> <el-checkbox v-model="checked" :disabled="system < 5 || isChakan" style="font-size: 16px">自动颜色样本</el-checkbox>
						<el-tooltip placement="right-start">
						<div slot="content" class="el_tip_box">
							勾选刊登的产品会自动以变体SKU主图作为颜色样本（变体缩略图）
						</div>
						<img :src="urlQueImg" class="item_img" alt/>
					</el-tooltip>
					</div>
					<div v-if="system == 5 && !isChakan">
						<el-button type="primary" icon="el-icon-plus" @click="addItem" v-if="!onlineEdit">添加一行</el-button>
						<el-button type="primary" icon="el-icon-plus" @click="addPiliang" v-if="headerList.length > 0 && !onlineEdit">批量添加</el-button>
						<el-button type="danger" icon="el-icon-delete" @click="removeAll" v-if="!onlineEdit">批量移除</el-button>
					</div>
				</div>

				<!-- 头部 -->
				<el-table :row-class-name="tableRowClassName"
						:data="tableList"
						style="width: 100%;margin-top: 6px;"
						v-loading="load_data"
						element-loading-text="拼命加载中"
						border
						@selection-change="on_batch_select"
						:header-cell-style="iscenter"
				>
					<!-- :cell-style="style" -->
					<el-table-column
							width="50"
							type="selection"
							fixed
							align="center"
					></el-table-column>
					<el-table-column
						min-width="100"
						width="180"
						label="产品图"
						align="center"
						prop="imageList"
						fixed
				>
					<template slot-scope="scope">
						<template v-if="scope.row.imageList && scope.row.imageList.length">
							<div class="table_image_box">
								<el-tooltip placement="bottom" effect="light" v-for="(item,index2) in scope.row.imageList" :key="index2" v-if="index2 < 2 && system == 5 && !isChakan">
									<div class="image_input_tip_slot" slot="content">
										<div class="item_click_slot" v-for="(itemHeader,index) in headerList" @click="hangdeYingyong(scope,index)">数据应用到-同{{itemHeader.nameCn}}</div>
									</div>
									<img class="item_image_box" :src="item" alt @click="shouImage(scope.row.imageList)"/>
								</el-tooltip>
								<div v-for="(item,index2) in scope.row.imageList" :key="index2" v-if="index2 < 2 && (system < 5 || isChakan)">
									<img class="item_image_box" :src="item" alt @click="shouImage(scope.row.imageList)"/>
								</div>
								<div style="display: flex;align-items: center;justify-content: center;border: 1px solid darkgrey;cursor: pointer" class="item_image_box" @click="Select_pictures(scope.row)" v-if="system == 5 && !isChakan">
									 <i class="el-icon-plus" style="font-size: 22px"></i>
								</div>
							</div>
						</template>
						<template v-else>
							<el-button
									:disabled="system < 5 || isChakan"
									@click="Select_pictures(scope.row)"
							>选择图片</el-button
							>
						</template>
					</template>
				</el-table-column>
					<el-table-column
							fixed
							min-width="320"
					>
						<template slot="header" slot-scope="scope">
							<div class="item_header_title"><span class='item_bitian'>*</span>标题</div>
							<div class="item_header_title"><el-link type="primary" @click="YijianBiaoti(scope)" v-if="system == 5 && !isChakan">一键生成</el-link></div>
							<div class="item_header_title"><el-link type="primary" @click="clickHeader(scope)" v-if="system == 5 && !isChakan">同首行</el-link></div>
						</template>
						<template slot-scope="scope">
							<el-input v-model="scope.row.name" :disabled="system < 5 || isChakan"></el-input>
						</template>
					</el-table-column>
					<el-table-column
							prop="offerId"
							fixed
							min-width="320"
					>
						<template slot="header" slot-scope="scope">
							<div class="item_header_title"><span class='item_bitian'>*</span>SKU编号</div>
							<div class="item_header_title"><el-link type="primary" @click="clickYijian(scope)" v-if="system == 5 && !isChakan">一键生成</el-link></div>
						</template>
						<template slot-scope="scope">
							<el-input v-model="scope.row.offerId" :disabled="system < 5 || isChakan"></el-input>

						</template>
					</el-table-column>
					<el-table-column
							prop="price"
							fixed
							min-width="110"
							width="130"
							show-overflow-tooltip
					>
						<template slot="header" slot-scope="scope">
							<div class="item_header_title"><span class='item_bitian'>*</span>售价({{bizhong}})</div>
							<div class="item_header_title"><el-link type="primary" @click="clickHeader(scope)" v-if="system == 5 && !isChakan">同首行</el-link></div>
							<div class="item_header_title"><el-link type="primary" @click="clickDingjia(scope)" v-if="system == 5 && !isChakan">定价计算</el-link></div>
						</template>
						<template slot-scope="scope">
							<div class="image_input">
								<el-input v-model="scope.row.price"  @focus="handleFocus(scope)"  @blur="handleBlur(scope)" :disabled="system < 5 || isChakan"
										  oninput ="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')">
								</el-input>
								<el-tooltip placement="bottom" effect="light">
									<div class="image_input_tip_slot" slot="content">
										<div class="item_click_slot" v-for="(itemHeader,index) in headerList" @click="hangdeYingyong(scope,index)">数据应用到-同{{itemHeader.nameCn}}</div>
									</div>
									<img v-show="tableList[scope.$index].isShowImage && scope.column.property == fouceFiled"
										 :src="urlDHImg" class="item_img_ipput" alt/>
								</el-tooltip>
							</div>

						</template>
					</el-table-column>
					<el-table-column
							prop="oldPrice"
							fixed
							width="130"
							show-overflow-tooltip
					>
						<template slot="header" slot-scope="scope">
							<div class="item_header_title"><span class='item_bitian'>*</span>原价({{bizhong}})</div>
							<div class="item_header_title"><el-link type="primary" @click="clickHeader(scope)" v-if="system == 5 && !isChakan">同首行</el-link></div>
						</template>
						<template slot-scope="scope">
							<div class="image_input">
								<el-input v-model="scope.row.oldPrice"  @focus="handleFocus(scope)"  @blur="handleBlur(scope)" :disabled="system < 5 || isChakan"
										  oninput ="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')">
								</el-input>
								<el-tooltip placement="bottom" effect="light">
									<div class="image_input_tip_slot" slot="content">
										<div class="item_click_slot" v-for="(itemHeader,index) in headerList" @click="hangdeYingyong(scope,index)">数据应用到-同{{itemHeader.nameCn}}</div>
									</div>
									<img v-show="tableList[scope.$index].isShowImage && scope.column.property == fouceFiled"
										 :src="urlDHImg" class="item_img_ipput" alt/>
								</el-tooltip>
							</div>

						</template>
					</el-table-column>
					<el-table-column
							label="库存"
							prop="stock"
							fixed
							width="80"
							show-overflow-tooltip
					>
						<template slot="header" slot-scope="scope">
							<div class="item_header_title"><span class='item_bitian'>*</span>库存</div>
							<div class="item_header_title"><el-link type="primary" @click="clickHeader(scope)" v-if="system == 5 && !isChakan">同首行</el-link></div>
						</template>
						<template slot-scope="scope">
							<div class="image_input">
								<el-input v-model="scope.row.stock"  @focus="handleFocus(scope)"  @blur.stop="handleBlur(scope)" :disabled="system < 5 || isChakan"  oninput ="value=value.replace(/[^0-9]/g,'')">
								</el-input>
								<el-tooltip placement="bottom" effect="light">
								<div class="image_input_tip_slot" slot="content">
									<div class="item_click_slot" v-for="(itemHeader,index) in headerList" @click="hangdeYingyong(scope,index)">数据应用到-同{{itemHeader.nameCn}}</div>
								</div>
								<img v-show="tableList[scope.$index].isShowImage && scope.column.property == fouceFiled"
									 :src="urlDHImg" class="item_img_ipput" alt/>
							</el-tooltip>
							</div>
						</template>
					</el-table-column>
					<el-table-column
							v-for="(item,index) in headerList"
							:key="item.id"
							min-width="160"
					>
						<template slot="header" slot-scope="scope">
							<div class="item_header_title">
								<div style="word-wrap: break-word;">
									<span class='item_bitian' v-if="item.isRequired == 1">*</span>
									{{item.name}}({{item.nameCn}})
									<el-tooltip placement="right-start">
									<div slot="content" class="el_tip_box">
										({{item.descriptionCn}})
									</div>
									<img :src="urlQueImg" class="item_img" alt/>
								</el-tooltip>
								</div>
							</div>
							<div class="item_header_title">
								<el-link type="primary" @click="clickHeader2(index)" v-if="system == 5 && !isChakan">同首行</el-link>
							</div>
							<div class="item_header_title">
								<el-link type="primary" style="color: red" @click="yichu(item,index)" v-if="!onlineEdit && system == 5 && !isChakan">移除</el-link>
							</div>
						</template>
						<template slot-scope="scope">
							<template v-if="item.type != 'Boolean'">
								<template  v-if="item.dictionaryId == 0">
									<el-input v-if="item.type == 'Integer'" class="shuxing_input" v-model="attrErweiList[scope.$index][index].value" :disabled="system < 5 || isChakan"  oninput ="value=value.replace(/[^0-9]/g,'')">
									</el-input>
									<el-input v-else-if="item.type == 'Decimal'" class="shuxing_input" v-model="attrErweiList[scope.$index][index].value" :disabled="system < 5 || isChakan"
											  oninput ="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(?!\.|$)/g, '')">
									</el-input>
									<el-input v-else class="shuxing_input" v-model="attrErweiList[scope.$index][index].value" :disabled="system < 5 || isChakan">
									</el-input>
								</template>
								<el-select filterable  v-if="item.dictionaryId != 0" :multiple="item.isCollection == 1"
										   v-model="attrErweiList[scope.$index][index].value"  class="shuxing_select" clear filterable :disabled="system < 5 || isChakan"
								>
									<el-option
											v-for="itemselect in item.attributeValues"
											:key="itemselect.valueId"
											:label="itemselect.valueCn"
											:value="itemselect.value"
									></el-option>
								</el-select>
							</template>
							<template v-if="item.type == 'Boolean'">
								<el-radio-group v-model="item.fieldValue">
									<el-radio :label="true">是</el-radio>
									<el-radio :label="false">否</el-radio>
								</el-radio-group>
							</template>
						</template>
					</el-table-column>

					<el-table-column
							fixed="right"
							width="90"
							align="center"
							show-overflow-tooltip
							v-if="system == 5 && !isChakan"
					>
						<template slot="header" slot-scope="scope">
							<div class="item_header_title">操作</div>
						</template>
						<template slot-scope="scope">
							<el-button v-if="tableList.length > 1 && !onlineEdit" type="danger" @click="removeItem(scope)">移除</el-button>
						</template>
					</el-table-column>

				</el-table>
			</div>
		</div>
		<dingjia ref="dingjia" @changeReamrk="changeReamrk" @changeDingjia="changeDingjia"/>
		<el-dialog
				title="选择图片"
				:modal-append-to-body="false"
				append-to-body
				:visible.sync="dialogFormVisible"
				width="1000px"
				@close="variantSelectImgDialogClose"
		>
			<el-alert
					title="变体图片最多选择15张"
					type="error"
					:closable="false"
			></el-alert>
			<div style="display: flex;flex-wrap: wrap;margin-top: 5px;width: 950px">
				<div style="position:relative;margin: 5px" v-for="(item,index) in imgSelectList" :key="index" class="option" @click="changeVariantSelectImg(item, index)">
					<div
							class="img-mask"
							v-if="
							variantCheckedImgUidList.some((key) => key === item)
						"
					>
						<i class="el-icon-upload-success el-true-check">
							{{ getVariantSelectImgIndex(item) }}
						</i>
					</div>
					<img :src="item" alt />
<!--					<img alt :src="item.url" style="width: 80px;height: 80px;cursor: pointer"/>-->
<!--					<img v-show="item.isChecked" :src="urlCheckImg" class="item_img" alt style="position: absolute;right: 0;top: 0"/>-->
				</div>
			</div>

			<el-divider v-if="imgSelectList.length && imgSelectList.length > 0" style="margin-top: -10px"></el-divider>
			<el-upload
					:action="upload_url"
					accept="image/gif, image/jpeg, image/tiff"
					drag
					multiple
					list-type="picture-card"
					:on-success="onSuccess"
					:show-file-list="false"
					:on-remove="handleRemove"
					:headers="customHeaders"
			>
				<i class="el-icon-upload"></i>

				<div class="el-upload__text">
					<span>将文件拖到此处，或</span>
					<em>选择图片</em>
				</div>
				<div class="el-upload__tip" slot="tip">
					只能上传JPG/PNG文件，且不超过2M
				</div>
			</el-upload>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click="dialogFormVisible = false"
				>取 消</el-button
				>
				<el-button
						size="mini"
						type="primary"
						@click="saveVariantSelectImg()"
				>确 定</el-button
				>
			</div>
		</el-dialog>
		<el-dialog
				title="批量添加"
				:visible.sync="dialogVisible"
				:modal-append-to-body="false"
				append-to-body
				width="1200px"
				top="6vh"
		>
			<div class="shuxing_box">
				<div class="item_shuxing" v-for="(item,index) in headerList2" :key="index">
					<div class="shuxing_label">
						<span class="shuxing_label_bitian" v-if="item.isRequired == 1">*</span>
						{{item.name}}（{{item.nameCn}})
						<el-tooltip placement="right-start" v-if="item.descriptionCn">
							<div slot="content" class="el_tip_box">
								{{item.descriptionCn}}
							</div>
							<img :src="urlQueImg" class="item_img" alt/>
						</el-tooltip>
					</div>
					<el-input class="shuxing_input" v-model="item.fieldValue"  v-if="item.dictionaryId == 0">
					</el-input>
					<el-select filterable  v-if="item.dictionaryId != 0" multiple
							   v-model="item.fieldValue"  class="shuxing_select" clear  filterable
					>
						<el-option
								v-for="itemselect in item.attributeValues"
								:key="itemselect.valueId"
								:label="itemselect.valueCn"
								:value="itemselect.value"
						></el-option>
					</el-select>
				</div>
			</div>
			<span slot="footer" style="margin-top: 60px">
					<el-button type="primary" @click="queren"  :loading="isLoading">确 认</el-button>
					<el-button @click="dialogVisible = false">关 闭</el-button>
  			</span>
		</el-dialog>
		<el-dialog
				title="已选图片"
				:visible.sync="dialogImageVisible"
				:modal-append-to-body="false"
				append-to-body
				width="1100px"
				top="6vh"
		>
			<div style="display: flex;flex-wrap: wrap;margin-top: 5px;width: 1050px">
				<div style="position:relative;margin: 5px" v-for="(item,index) in biantiImgList" :key="index" class="option" @click="changeVariantSelectImg(item, index)">
					<img :src="item" alt />
				</div>
			</div>
			<span slot="footer" style="margin-top: 60px">
					<el-button type="primary" @click="dialogImageVisible = false">确 认</el-button>
					<el-button @click="dialogImageVisible = false">关 闭</el-button>
  			</span>
		</el-dialog>
	</div>
</template>
<script>
	import dingjia from './dingjia'
	import { Baseurl,ajaxGet } from '@/api/api/api'
	export default {
		name: 'biantiComp',
		components: {
			dingjia
		},
		props: {
			imgSelectList: {
				type: Array,
				default() {
					return []
				},
			},
			// score: {
			// 	type: Array,
			// 	default() {
			// 		return [0,0,0,0];
			// 	},
			// }
		},
		data() {
			return {
				//是否为查看
				isChakan:false,
				isShowBianti:true,
				biantiImgList: [],
				//在线产品编辑
				dialogImageVisible:false,
				system:5,
				variantCheckedImgUidList: [],
				//在线产品编辑
				onlineEdit:false,
				isLoading:false,
				dingjiaStatus:'',
				//批量添加
				dialogVisible: false,
				ParentSKU:'',
				ParentName:'',
				//二维的数组
				attrErweiList:[],
				FileList:[],
				batch_select:[],
				//进来后这个行数据的图片数组
				itemImageList:[],
				//点击所选变体对象  不能删啊
				selectBiantiRow:{},
				//变体对象数组
			//	selectBiantiImageList:[],
				variantcontent: '展开',
				varianttypt: true,
				specsIndex: '', //颜色尺寸
				variantText: '', //选择尺寸和颜色后获取的值
				recommendSpecs: {}, //显示尺寸和颜色的规格
				tableData: [],
				ossParams: {},
				// 颜色 和 尺寸 的先后顺序决定变体标识，不可换！！！
				selectVariants: {
					颜色: [],
					尺寸: [],
				},
				dialogVariantVisible: false, //变体设置
				specs: [{ title: '颜色' }, { title: '尺寸' }],
				dialogType: '',
				dialogFormVisible: false, //选择图片
				isShowVariantImg: false, //已选图片
				dialogImageUrl: '',
				variant_price_same_value: '', //加减价/￥
				variant_price_value: '', //重新定价
				variantImages: [], //已选图片
				Selected_pictures_value: '', //已选图片选择变体的值
				substitution: false,
				variantSelectImage_form: {
					variant: '',
					index: '',
					images: [],
					images_sort: [],
				},
				upload_url: Baseurl + 'imageController/uploadImage',

				childValue: '',
				// productPicUrl: [],
				// fatherSKU: "",
				// watchfather: "",
				checkedSKU: '',
				customHeaders: { token: localStorage.getItem('token') },
				loadingTable: false,
				fouceFiled:'',
				//问号图标的地址
				urlQueImg:require('@/assets/images/wenhao.png'),
				//导航图标的地址
				urlDHImg:require('@/assets/images/daohang.png'),
				//选中图表
				urlCheckImg:require('@/assets/images/checkbox.png'),
				pageType: '',
				checked:true,
				biaohongList:[],
				tableList:[
					{
						name:'',
						oldPrice:'',//原价
						price:'',//现价
						stock:'',//库存
						isShowImage:false,//是否展示输入框按钮
						offerId:'',//卖家产品id(自定义sku) 父sku拼接颜色/尺寸等
						primaryImage:'', //主图
						imageList:[],
						colorImage:'',//营销色彩
					}
						],
				load_data:false,
				operateWidth: 200,
				iscenter: {
					textAlign: 'center',
					background: '#f8f8f8',
					color: '#232323',
				},
				//表头数据
				headerList:[

				],
				//批量添加
				headerList2:[

				],
				//是否点击了移除按钮
				isYichu:false,
				//编辑状态保存的变体信息
				oldTableList:[],
				bizhong:'CNY'
				//oldAttrErweiList:[]
			}
		},
		created() {
			this.dingjiaStatus = ''
			this.system = JSON.parse(localStorage.getItem('role')).system
		},
		methods: {
			resetBianti(){
				this.isShowBianti = false
				this.attrErweiList = []
				this.tableList = []
				this.oldTableList = []
				this.biaohongList = []
				this.headerList = []
			},
			setBiantiList2(list1,list2){
				this.biaohongList = []
				this.attrErweiList = list2
				//this.oldAttrErweiList = JSON.parse(JSON.stringify(list2))
				this.headerList = list1
			},
			//这个接口的list 存放列
			setBiantiList(list){
				this.tableList = [
					{
						name:'',
						oldPrice:'',//原价
						price:'',//现价
						stock:'',//库存
						isShowImage:false,//是否展示输入框按钮
						offerId:'',//卖家产品id(自定义sku) 父sku拼接颜色/尺寸等
						primaryImage:'', //主图
						imageList:[],
						colorImage:'',//营销色彩
					}
				]
				this.oldTableList = []
				this.biaohongList = []
				this.headerList = list
				let itemArr = []
				this.headerList.forEach(itemHeader =>{
					let itemObj ={
						value :undefined
					}
					//输入框
					if (itemHeader.dictionaryId == 0){
						itemObj.value = ''
					}
					//单选
					if (itemHeader.dictionaryId != 0 && itemHeader.isCollection == 0){
						itemObj.value = ''
					}
					//多选
					if (itemHeader.dictionaryId != 0 && itemHeader.isCollection == 1){
						itemObj.value = []
					}
					itemArr.push(itemObj)
				})
				this.attrErweiList.push(itemArr)
				this.isShowBianti = true
			},
			//增加一个变体属性到列表表头
			addBianti(item){
				item.isAspect = 1
				this.attrErweiList = this.attrErweiList.map(itemArr => {
					if (item.fieldValue){
						itemArr.push({
							value:item.fieldValue
						})
					} else {
						let itemObj ={
							value :undefined
						}
						//输入框
						if (item.dictionaryId == 0){
							itemObj.value = ''
						}
						//单选
						if (item.dictionaryId != 0 && item.isCollection == 0){
							itemObj.value = ''
						}
						//多选
						if (item.dictionaryId != 0 && item.isCollection == 1){
							itemObj.value = []
						}
						itemArr.push(itemObj)
					}

					return itemArr
				})
				this.headerList.push(item)
			},
			addItem() {
				if (this.headerList.length > 0){
					let itemArr = []
					this.headerList.forEach(itemHeader =>{
						let itemObj ={
							value :undefined
						}
						//输入框
						if (itemHeader.dictionaryId == 0){
							itemObj.value = ''
						}
						//单选
						if (itemHeader.dictionaryId != 0 && itemHeader.isCollection == 0){
							itemObj.value = ''
						}
						//多选
						if (itemHeader.dictionaryId != 0 && itemHeader.isCollection == 1){
							itemObj.value = []
						}
						itemArr.push(itemObj)
					})
					this.attrErweiList.push(itemArr)
				}
				let itemObj = {
					name:'',
					oldPrice:'',//原价
					price:'',//现价
					stock:'',//库存
					isShowImage:true,//是否展示输入框按钮
					offerId:'',//卖家产品id(自定义sku) 父sku拼接颜色/尺寸等
					primaryImage:'', //主图
					imageList:[]
				}
				this.tableList.push(itemObj)
			},


			on_batch_select(val) {
				this.batch_select = val
				// this.batch_select = val;
			},
			//定价计算
			clickDingjia(scope){
				if (this.dingjiaStatus != 'click'){
					this.dingjiaStatus = 'click'
					this.$refs.dingjia.dialogVisible = true
					this.$refs.dingjia.ruleForm.caigoudanjia = undefined
					this.$refs.dingjia.ruleForm.leimuyongjin = undefined
					this.$refs.dingjia.ruleForm.guanggao = 9
					this.$refs.dingjia.ruleForm.caigouyunfei = undefined
					this.$refs.dingjia.ruleForm.tixianshouxu = 0.7
					this.$refs.dingjia.ruleForm.cuxiaohuodong = 15
					this.$refs.dingjia.ruleForm.zhongliang = undefined
					this.$refs.dingjia.ruleForm.jinglilv = 20
					this.$refs.dingjia.ruleForm.yuguyunfei = undefined
					this.$refs.dingjia.ruleForm.shoujia = undefined
					this.$refs.dingjia.ruleForm.beizhuguocheng = undefined
				} else {
					this.$refs.dingjia.dialogVisible = true
				}

			},
			//同首行
			clickHeader(scope){
				let property = scope.column.property
				this.tableList.forEach(item =>{
					item[property] = this.tableList[0][property]
				})
			},
			//变体属性同首行
			clickHeader2(index){
				this.attrErweiList.forEach(item =>{
					item[index].value= this.attrErweiList[0][index].value
				})
			},
			//一键生成标题
			YijianBiaoti(){
				if (!this.ParentName){
					this.$message('请先输入父标题')
					return
				}
				this.createName()
			},
			createName(){
				this.tableList = this.tableList.map((item,index) =>{
					item.name =  (this.ParentName + this.returnSku(index))
					return item
				})
			},
			//移除一个
			removeItem(scope){
				this.tableList.splice(scope.$index,1)
				this.attrErweiList.splice(scope.$index,1)
				this.isYichu = true
			},
			removeAll(value) {
				if(this.batch_select.length == 0){
					return this.$alert('请至少勾选一项变体属性！', '提示', {
						confirmButtonText: '确定',
					})
				}
				if(this.batch_select.length == this.tableList.length){
					return this.$alert('请至少保留一项变体属性！', '提示', {
						confirmButtonText: '确定',
					})
				}
				//存放移除的下标
				let arrList = []
				this.tableList = JSON.parse(JSON.stringify(this.tableList.filter((item,index) => {
					//相等说明对象
					let ss = this.batch_select.some(itemSome =>{
						return item == itemSome
					})
					if (ss){
						arrList.push(index)
					}
					return !ss
				}))),
				this.attrErweiList = JSON.parse(JSON.stringify(this.attrErweiList.filter((item,index) =>{
					return !arrList.some(itemSome =>{
						return index == itemSome
					})
				})))

				this.batch_select = []
				this.isYichu = true
			},
			//聚焦后显示图片
			handleFocus(scope){
				this.tableList.forEach((item,index) => {
					item.isShowImage = (index == scope.$index)
				})
				this.fouceFiled = scope.column.property
			},
			//失去后隐藏图片
			handleBlur(scope){
				// scope.row.isShowImage = false
				// this.fouceFiled = ''
			},
			//数据批量应用
			hangdeYingyong(scope,index){
				let value = this.attrErweiList[scope.$index][index].value
				//记录下标
				let kongArr = []
				this.attrErweiList.filter((item,atrIndex) => {
					if (item[index].value && value && item[index].value.toString() == value.toString()){
						kongArr.push(atrIndex)
					}
				})
				let value2 = scope.row[scope.column.property]
				kongArr.forEach(item => {
					this.tableList[item][scope.column.property] = value2
				})
			},
			addImageToBianti(row){
				this.$refs.uploadPicture.dialogVisibleSelect = true
			},

			// 选择图片
			Select_pictures(row) {
				this.itemImageList = []
				this.FileList = []
				this.dialogFormVisible = true
				this.selectBiantiRow = row
			//	this.selectBiantiImageList= row.imageList
				//选中图片的逻辑
				// this.imgSelectList.forEach(item =>{
				// 	if(row.imageList && row.imageList.length > 0){
				// 		if (row.imageList.some(itemImg =>{
				// 			return itemImg == item.url
				// 		})){
				// 			item.isChecked = true
				// 		}
				// 	} else {
				// 		item.isChecked = false
				// 	}
				// })
			},
			// beforeUpload(file){
			// 	let seImageList = this.imgSelectList.filter(item =>{
			// 		return item.isChecked
			// 	})
			// 	if (seImageList.length + this.itemImageList.length > 15){
			// 		this.$message('变体图片最多选择15张')
			// 		return
			// 	}
			// },
			//成功回调
			onSuccess(response, file, fileList) {
				// this.itemImageList = fileList.map(item =>{
				// 	return item.response.data
				// })
				// const imgPath = file.response.data
				// this.$emit('addImg', imgPath)
				//

				this.$emit('addImageList',[file.response.data])
			},

			// 删除图片
			handleRemove(file, fileList) {
				this.itemImageList = fileList.map(item =>{
					return item.response.data
				})
			},

			// 选择图片确定
			saveVariantSelectImg() {
				this.selectBiantiRow.imageList = this.variantCheckedImgUidList
				this.variantCheckedImgUidList = []
				this.dialogFormVisible = false
			// 	this.FileList = []
			// 	let seImageList =  []
			// 	this.imgSelectList.map(item =>{
			// 	if (item.isChecked){
			// 		seImageList.push(item.url)
			// 	}
			// })
			// 	let imageList = seImageList.concat(this.itemImageList)
			// 	if (imageList.length > 15){
			// 		return this.$message('变体图片最多选择15张')
			// 	}
			// 	this.$emit('addImageList',this.itemImageList)
			},
			clickLog(scope,clickLog,value){
			},
			changeAttr(index){
			},
			//操作栏移除一行
			yichu(item,index){
				if (this.attrErweiList.length > 0 && this.attrErweiList[0].length > 1){
				//	item.fieldValue = this.attrErweiList[0][index].value
					item.fieldValue = undefined
          let newErwei = [...this.attrErweiList]
          let newHeaderList = [...this.headerList]
          newHeaderList.splice(index,1)
          newErwei.forEach(item2 =>{
						item2.splice(index,1)
					})
          this.headerList = []
          this.attrErweiList = []
          setTimeout(()=>{
            this.headerList = newHeaderList
            this.attrErweiList = newErwei
          },10)

					this.$emit('changeTopAttr',[item])
				} else {
					this.attrErweiList = []
					this.headerList = []
				}
			},
			//必填没填返回true
			returnBitian(){
				return this.headerList.some((item,index) => {
					return item.isRequired && this.attrErweiList.some(itemsome =>{
						return itemsome[index].vallue == [] || !itemsome[index].vallue
					})
				})
			},
			//一键生成
			clickYijian(){
				if (!this.ParentSKU){
					this.$message('请先生成父SKU')
					return
				}
				this.tableList.forEach((item,index) =>{
					item.offerId =  (this.ParentSKU + this.returnSku(index))
				})
				//ParentSKU
			},
			// 重复 true 不重复 false
			returnBianti(){
				if (this.headerList.length == 0){
					return true
				} else {
					let kongList = []
					this.biaohongList = []
					this.attrErweiList.forEach((item,index) =>{
						if (kongList.some((itemSome,indexSome) =>{
							return itemSome == JSON.stringify(item)
						})){
							kongList.forEach((itemEach,indexEach) => {
								if (itemEach == JSON.stringify(item)){
									this.biaohongList[indexEach] = true
								}
							})
							this.biaohongList.push(true)
						} else {
							this.biaohongList.push(false)
							kongList.push(JSON.stringify(item))
						}
					})
					return kongList.length != this.attrErweiList.length
				}
			},
			//返回sku拼接
			returnSku(index){
				let returnStr =  ''
				if (this.attrErweiList.length > 0){
					this.attrErweiList[index].forEach(item => {
						//item是数组
						if (typeof item.value === "object" && Array.isArray(item.value)){
							let str = ''
							if (item.value.length > 0){
								item.value.forEach(itemValue =>{
									itemValue = !itemValue ? 'no' :itemValue
									str = str + itemValue +'/'
								})
							}
							returnStr = returnStr + '_' + str.slice(0, -1);
						} else {
							if (item.value){
								returnStr = returnStr + '_' +item.value
							}
						}
					})
				} else {
					returnStr = ''
				}
				return returnStr
			},
			//批量添加
			addPiliang() {
				this.headerList2 = JSON.parse(JSON.stringify(this.headerList.map(item =>{
					if (item.dictionaryId == '0'){
						item.fieldValue = ''
					} else {
						item.fieldValue = []
					}
					return item
				})))
				this.dialogVisible = true
			},
			//确认
			queren(){
				this.isLoading = true
				// if (!this.headerList2.some(item =>{
				// 	return (item.fieldValue != '' && item.fieldValue != undefined && (item.fieldValue && item.fieldValue.lenght == 0))
				// })){
				// 	this.$message('最少选择一个变体属性！')
				// 	return
				// }
				this.headerList2.forEach(item =>{
					if (item.dictionaryId != '0' && item.fieldValue.length == 0){
						item.fieldValue = ['shanchu']
					}
					if (item.dictionaryId == '0' && !item.fieldValue){
						item.fieldValue = 'shanchu'
					}
				})


				let allLength = 1
				this.headerList2.forEach((item,index) => {
					let itemObj ={
						value:undefined
					}
					if (item.dictionaryId == 0){
						if (item.fieldValue){
							item.selectList = item.fieldValue.split(',')
						} else {
							item.selectList = []
						}
						itemObj.value = ''
					} else {
						item.selectList = item.fieldValue
						//多选
						if (item.isCollection == 1){
							itemObj.value = []
						} else {
							itemObj.value = ''
						}
					}
					allLength = allLength * item.selectList.length
				})

				let ss = this.headerList2.map(item => {
					return item.selectList
				})
				for (let i = 0; i < allLength; i++) {
					let itemTable = {
						name:'',
						oldPrice:'',//原价
						price:'',//现价
						stock:'',//库存
						isShowImage:false,//是否展示输入框按钮
						offerId:'',//卖家产品id(自定义sku) 父sku拼接颜色/尺寸等
						primaryImage:'', //主图
						imageList:[]
					}
					this.tableList.push(itemTable)
				}
				let linshi = this.getListAtriValues(ss)
        console.log(linshi)
				let newAttrList = linshi.map(item => {
					return item.map((itemNew,index) =>{
						let itemObj={
							value:undefined
						}
						//输入框
						if (this.headerList[index].dictionaryId == 0){
							itemObj.value = itemNew
						}
						//单选
						if (this.headerList[index].dictionaryId != 0 && this.headerList[index].isCollection == 0){
							itemObj.value = itemNew
						}
						//多选
						if (this.headerList[index].dictionaryId != 0 && this.headerList[index].isCollection == 1){
							itemObj.value = [itemNew]
						}
						return itemObj
					})
				})
				let sss = newAttrList.map((item) => {
					return item.map((itemFor,index) => {
						let obj = {
							value:itemFor.value
						}
						if (this.headerList2[index].dictionaryId == 0 && itemFor.value == 'shanchu'){
							obj.value = ''
						}
						if (this.headerList2[index].dictionaryId != 0 && this.headerList2[index].isCollection == 0 && itemFor.value == 'shanchu'){
							obj.value = ''
						}
						if (this.headerList2[index].dictionaryId != 0 && this.headerList2[index].isCollection == 1 && itemFor.value && itemFor.value.length > 0 && itemFor.value[0] =='shanchu'){
							obj.value = []
						}
						return obj
					})
				})
				this.dialogVisible = false
				this.isLoading = false
				this.attrErweiList = this.attrErweiList.concat(sss)

			},
			getListAtriValues(list){
					let randomList = list;
					// 用于记录每个元素的长度
					let lenAll = new Array(randomList.length);

					// 记录每个元素指针的位置
					let pointerAll = new Array(randomList.length).fill(0);
					let resultSize = 1;
					for (let i = 0; i < randomList.length; i++) {
						let item = randomList[i];
						lenAll[i] = item.length;
						resultSize *= item.length;
						pointerAll[i] = 0;
					}

					let result = [];
					for (let i = 1; i <= resultSize; i++) {
						let resultItem = [];
						for (let j = 0; j <= pointerAll.length - 1; j++) {
							resultItem.push(randomList[j][pointerAll[j]]);
						}
						result.push(resultItem);
						// 现在需要挪动指针位置了
						// 进行递归
						pointerAll[pointerAll.length - 1]++;
						for (let i = pointerAll.length - 1; i > 0; i--) {
							if (pointerAll[i] >= lenAll[i]) {
								pointerAll[i] = 0;
								pointerAll[i - 1]++;
							}
						}
					}
					return result
			},
			changeReamrk(val){
				this.$emit('changeReamrk',val)
			},
			changeDingjia(val){
				this.tableList.forEach(item =>{
					item.price = val
				})
			},
			getVariantSelectImgIndex(item) {
				const isHaveIndex = this.variantCheckedImgUidList.findIndex(
						(key) => key === item
				)
				return isHaveIndex + 1
			},
			changeVariantSelectImg(item) {
				if (this.variantCheckedImgUidList.length <= 0) {
					this.variantCheckedImgUidList.push(item)
				} else {
					const isHaveIndex = this.variantCheckedImgUidList.findIndex(
							(key) => key === item
					)

					if (isHaveIndex > -1) {
						this.variantCheckedImgUidList.splice(isHaveIndex, 1)
					} else {
						if (this.variantCheckedImgUidList.length < 15) {
							this.variantCheckedImgUidList.push(item)
						} else {
							this.$message.error('变体图片最多选择15张')
						}
					}
				}
			},
			variantSelectImgDialogClose() {
				this.variantCheckedImgUidList = []
			},
			tableRowClassName({row, rowIndex}){
				if (this.biaohongList.length > rowIndex && this.biaohongList[rowIndex]){
					return 'biaohong_table'
				} else {
					return ''
				}
			},
			shouImage(imgs){
				if (imgs.length == 0){
					return this.$message('暂无图片')
				}
				this.dialogImageVisible = true
				this.biantiImgList = imgs
			}
		}
	}
</script>
<style lang="scss" scoped>
	@import "../ozon.less";
	::v-deep .el-upload__text{
		display: flex;
		flex-direction: column;
		color: #606266;
		font-size: 14px;
		position: absolute;
		top: 30px;
		width: 100%;
		height: 100%;
		em {
			margin-top: -90%;
		}
	}
	::v-deep .el-upload el-upload--picture-card {
		width: 110px;
		height: 110px;
	}
	::v-deep .el-upload-dragger {
		width: 100%;
		height: 100%;
		border: none;
		position: relative;
	}
	.el_tip_box{
		width: 360px;
		font-size: 18px;
		background: rgb(39,39,39);
		border-radius: 10px;
		padding: 15px;
		color: whitesmoke;

	}
	.item_img{
		height: 16px;
		width: 16px;
		margin-left: 5px;
		cursor: pointer
	}
	.image_input{
		position: relative;
	}
	.item_img_ipput{
		position: absolute;
		right: 5px;
		top: 6px;
		height: 20px;
		width: 20px;
		cursor: pointer;
	}
	.Minister-top {
		width: 99%;
		border-radius: 4px;
		overflow: hidden;

		.Ministerbackground {
			background: #d7f0dbff;
		}
		.Minister-top-top {
			width: 100%;
			height: 40px;

			.Minister-top-left {
				width: 80px;
				line-height: 40px;
				float: left;
				text-align: center;
				font-size: 16px;
				color: #fff;
			}
			.bianti_desc{
				line-height: 40px;
				font-size: 16px;
			}

			.Minister-top-color {
				// color: #567801;
				background: #39b54a;
			}
		}
		.information_content {
			width: calc(100% - 22px);
			overflow: hidden;
			padding: 10px 10px;
			border: 1px solid rgba(168,168,168,0.8);
			border-bottom-left-radius: 10px;
			border-bottom-right-radius: 10px;
			border-top: none !important;
		}
	}
	.item_header_title{
		display: flex;
		align-items: center;
		justify-content: center;
		flex-wrap: wrap;
		.item_bitian{
			color: red;
		}
	}
	.image_input_tip_slot{
		.item_click_slot{
			font-size: 16px;
			padding: 0 10px;
			line-height: 30px;
			align-items: center;
			cursor: pointer;
		}
		.item_click_slot:hover{
			background: rgb(254,225,136);
		}
	}
	.table_image_box{
		display: flex;
		flex-wrap: nowrap;
	}
	.item_image_box{
		width: 40px;
		height: 40px;
		margin-right: 10px;
		cursor: pointer;
	}

	.shuxing_box{
		border-radius: 10px;
		padding: 10px 0;
		font-size: 16px;
		.item_shuxing{
			display: flex;
			margin-bottom: 4px;
			.shuxing_label{
				width: 30%;
				text-align: right;
				padding: 3px 10px;
				.shuxing_label_bitian{
					color: red;
					margin-right: 4px;
				}
			}
			.shuxing_input{
				width: 60%;
			}
			.shuxing_select{
				width: 60%;
			}
			.shuxing_button{
				width: 30px;
				height: 30px;
				padding: 0;
				display: flex;
				align-items: center;
				justify-content: center;
				background: rgb(255,183,82);
				color: white;
				font-weight: 700;
				font-size: 20px;
				margin-left: 10px;
			}
		}
	}

	.option {
		width: 148px;
		height: 148px;
		margin: 0 8px 8px 0;
		float: left;
		overflow: hidden;
		background-color: #fff;
		border: 1px solid #c0ccda;
		border-radius: 6px;
		box-sizing: border-box;
		position: relative;

		.img-mask {
			position: absolute;
			right: -17px;
			top: -7px;
			width: 46px;
			height: 26px;
			background: #13ce66;
			text-align: center;
			transform: rotate(45deg);

			.el-true-check {
				color: #fff;
				font-size: 12px;
				margin-top: 12px;
				transform: rotate(-45deg);
			}
		}

		img {
			width: 146px;
		}
	}
	::v-deep .biaohong_table{
		background-color: oldlace !important;
		::v-deep tr {
			background: none !important;
		}
	}
</style>
